import React from "react";
import { connect } from 'react-redux';

const ButtonTemplate = (props) => {
    let backgroundColor = props.appearance.match(new RegExp(/<#(.*?)>|<#(.*?)\/>/), 'g');
    backgroundColor = backgroundColor !== null ? "#"+(backgroundColor[1].indexOf("/") ? backgroundColor[1].replace("/","") : backgroundColor[1]) : "var(--primary-color)";
		
    return (
        <div style={{textAlign: "center", borderTop:'0'}} >
			<div className="kt-form__actions">
				<button
					type={"button"}
					className="btn tf-submit-btn" 
					style={{
						backgroundColor: backgroundColor,
						color: "var(--accent-color)",
						width:"100%",
					}}>
					<b><span dangerouslySetInnerHTML={{__html: props["label::"+props.language]}}></span></b>
				</button>
			</div>
		</div>
    );
};

const mapStateToProps = (state, props) => {
    return {
        ...props,
        ...state['questionsList'][props.questionId]
    };
}

export default connect(mapStateToProps)(ButtonTemplate);